import React, { Fragment, useState, useEffect } from "react";
import PropTypes from "prop-types";
import Moment from "react-moment";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom/cjs/react-router-dom.min";
import {
  getArticles,
  getRecentArticle,
  addArticleLike,
  removeArticleLike,
  addComment,
} from "../../actions/article";
import { getIMEArticles } from "../../actions/imearticle";

import LoggedInNav from "../layout/IME/LoggedInNav";
import LoggedOutNav from "../layout/IME/LoggedOutNav";
import TwoFARequest from "../layout/Innovators/TwoFARequest";
// import ReportUser from "../layout/IME/ReportUser";
import ShareArtilce from "../layout/Innovators/ShareArticle";
import NewMembers from "../layout/IME/NewMembers";
import RecentArticleComment from "../layout/Innovators/RecentArticleComment";
import ArticleItem from "../layout/Innovators/ArticleItem";
import GreenSpinner from "../../img/Green_Spinner.gif";

import IMEArticleItem from "../layout/IME/IMEArticleItem";
import Blocks from "../layout/IME/Blocks";

const Trending = ({
  auth: { user, channelid, verified },
  isAuthenticated,
  getArticles,
  getRecentArticle,
  getIMEArticles,
  article: {
    articles,
    recentarticle: {
      _id,
      avatar,
      articleimage,
      date,
      firstname,
      lastname,
      jobtitle,
      location,
      title,
      blocks,
      keywords,
      comments,
      likes,
    },
    articleloading,
  },
  imearticle: { imearticles, imearticleloading },
  addComment,
  addArticleLike,
  removeArticleLike,
}) => {
  const [comment, setComment] = useState("");
  const [noValue, setValue] = useState("");
  const [showAuthentication, setShowAuthentication] = useState(true);
  const [showArticle, setShowArticle] = useState(false);

  useEffect(() => {
    getArticles();
    getRecentArticle();
    getIMEArticles();
  }, [getArticles, getRecentArticle, getIMEArticles]);

  if (!isAuthenticated) {
    return <Redirect to="/" />;
  } else if (isAuthenticated && user && user.channelid !== "roland") {
    return <Redirect to="/" />;
  }

  return (
    <Fragment>
      {/* <ReportUser /> */}
      {showArticle && <ShareArtilce setShowArticle={setShowArticle} />}
      {verified && !isAuthenticated && (
        <TwoFARequest
          setShowAuthentication={setShowAuthentication}
          channelid={channelid}
          jobtitle={jobtitle}
          location={location}
        />
      )}
      {isAuthenticated && <LoggedInNav />}
      {!isAuthenticated && <LoggedOutNav />}
      <div>
        <div className="flex-only-trending">
          <NewMembers />
          {articleloading ? (
            <div className="profile-error">
              <img src={GreenSpinner} alt="profile-red-spinner" />
            </div>
          ) : (
            <div className="all-news">
              <div className="trending-search-container">
                <div className="article-search-container">
                  <form action="" className="trending-form-flex">
                    <div className="label-input">
                      <label htmlFor="" className="trending-labels green">
                        Search<i className="fas fa-search green mx-5"></i>
                      </label>
                      <div className="input-drop-down">
                        <div className="search-input-hidden">
                          <input
                            className="search-input-style"
                            type="text"
                            name="mentors"
                            placeholder="Enter User Name, Article Category or Keywords"
                          />
                          <button
                            className="article-search-button background-green"
                            type="submit"
                          >
                            <i className="fas fa-book-open fa-lg"></i>
                          </button>
                        </div>
                        {noValue && (
                          <div className="hero-search-results">
                            <div className="profile-drop-container">
                              <i className="far fa-user-circle fa-2x drop-down-icon green"></i>
                              <p className="drop-down-text">Innovator</p>
                            </div>
                            <div className="profile-drop-container">
                              <i className="fas fa-book-open fa-lg drop-down-icon green"></i>
                              <p className="drop-down-text">
                                Article Category or Keywords
                              </p>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </form>
                </div>
              </div>
              {articles && articles.length > 0 ? (
                <div>
                  <div className="current-news">
                    <div className="article-recent">
                      <div className="full-article-info">
                        <div className="poster">
                          <img
                            src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/article_images/${articleimage}`}
                            alt="article-image"
                            className="top-article-image"
                          />
                        </div>
                        <div className="article-info">
                          <div className="article-list-items">
                            <ul className="article-items">
                              <div className="article-relative">
                                <div className="article-avi-container">
                                  <img
                                    src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${avatar}`}
                                    className="article-avi"
                                    alt="avatar"
                                  />
                                  <i className="fas fa-ellipsis-v  mx-10 p-y cursor green"></i>
                                  <div className="article-modal">
                                    <ul className="modal-items">
                                      <li className="modal-item">
                                        <i className="fas fa-flag mx-5 white"></i>
                                        Report
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </div>
                              <li className="article-item-alt max-width">
                                <i className="fas fa-book-open mx-5 -1 green"></i>
                                {title}
                              </li>
                            </ul>
                          </div>
                          <div className="main-article-icons">
                            <ul className="trending-icons">
                              <li className="trending-icon">
                                <i className="far fa-clock mx-5 green"></i>
                                <Moment format="MM/DD/YYYY">{date}</Moment>
                              </li>
                              {isAuthenticated && (
                                <li className="trending-icon mx-5">
                                  <i
                                    className="far fa-thumbs-up mx-5 green cursor"
                                    onClick={() => addArticleLike(_id)}
                                  ></i>
                                  {likes
                                    ? likes.length > 0 && (
                                        <span>{likes.length}</span>
                                      )
                                    : null}
                                  <i
                                    className="far fa-thumbs-down green mx-5 cursor"
                                    onClick={() => removeArticleLike(_id)}
                                  ></i>
                                </li>
                              )}
                              <li className="trending-icon mx-5">
                                <i className="far fa-comment green mx-5 cursor"></i>
                                {comments
                                  ? comments.length > 0 && (
                                      <span>{comments.length}</span>
                                    )
                                  : null}
                              </li>
                              {isAuthenticated && (
                                <li className="trending-icon mx-10">
                                  <i className="far fa-share-square mx-5 green cursor"></i>
                                  Share
                                </li>
                              )}
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div className="article-desc" id="green-scroll">
                        <p className="article-title">{title}</p>
                        {keywords &&
                          keywords.length > 0 &&
                          keywords.map((keyword) => {
                            return (
                              <li className="keywordsArray green">
                                {keyword.text}
                              </li>
                            );
                          })}
                        <div className="article-caption">
                          <i className="far fa-user mx-5 green"></i>
                          <p className="caption">
                            Published by{" "}
                            <span className="green">
                              {firstname} {lastname}
                            </span>
                            , {jobtitle} from {location && location.city},{" "}
                            {location && location.state}
                          </p>
                        </div>
                        <div className="article-caption">
                          <i className="far fa-clock mx-5 green"></i>
                          <p className="caption">
                            <Moment format="MM/DD/YYYY">{date}</Moment>
                          </p>
                        </div>
                        <div className="article-p white">
                          <Blocks blocks={blocks} />
                        </div>
                        <div className="article-comments">
                          <div className="comments-title">
                            <i className="far fa-comment fa-lg mx-5 green"></i>
                            Comments
                          </div>
                          {isAuthenticated && (
                            <div className="comment-reply-input-container-alt">
                              <form
                                onSubmit={(e) => {
                                  e.preventDefault();
                                  addComment({ comment, _id });
                                  setComment("");
                                }}
                                className="comment-reply-input-hidden"
                              >
                                <input
                                  type="text"
                                  className="comment-reply-input"
                                  name="comment"
                                  value={comment}
                                  onChange={(e) => setComment(e.target.value)}
                                  placeholder="Enter your comment here..."
                                />
                                <button className="comment-reply-input-button background-green">
                                  <i className="far fa-comments"></i>
                                </button>
                              </form>
                            </div>
                          )}
                          {comments
                            ? comments.map((comment) => (
                                <RecentArticleComment
                                  key={comment._id}
                                  comment={comment}
                                  id={_id}
                                />
                              ))
                            : null}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="recent-articles-section">
                    {articles.map((article) => (
                      <ArticleItem
                        key={article._id}
                        article={article}
                        isAuthenticated={isAuthenticated}
                      />
                    ))}
                  </div>
                </div>
              ) : (
                <p className="empty-content-trending green">
                  No Articles Found
                </p>
              )}
            </div>
          )}
          <div className="articles">
            <div className="online-title-container-alt">
              <div className="border-alt green">
                <p className="online-title-alt green">ime Articles</p>
              </div>
            </div>
            {imearticles.map((imearticle) => (
              <IMEArticleItem
                key={imearticle._id}
                imearticle={imearticle}
                isAuthenticated={isAuthenticated}
              />
            ))}
          </div>
        </div>
      </div>
    </Fragment>
  );
};

Trending.propTypes = {
  auth: PropTypes.object.isRequired,
  getArticles: PropTypes.func.isRequired,
  imearticle: PropTypes.object.isRequired,
  getIMEArticles: PropTypes.func.isRequired,
  article: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  isAuthenticated: state.auth.isAuthenticated,
  article: state.article,
  imearticle: state.imearticle,
  comment: state.comment,
  reply: state.reply,
});

export default connect(mapStateToProps, {
  getArticles,
  getRecentArticle,
  getIMEArticles,
  addComment,
  addArticleLike,
  removeArticleLike,
})(Trending);
